import React, { Component } from 'react';
import { withFormik, Field } from 'formik';
import * as yup from 'yup';
import { TEXT_LINK, IMAGE_LINK } from 'helpers/constants';

import ButtonCustom from 'components/ButtonCustom';
import FieldInputComponent from 'components/FieldInputComponent';
import FieldUploadImage from 'components/FieldUploadImage';

import listDropImg from 'images/list-drop-img.svg';
import checkedIcon from 'images/checked-icon.svg';
import closeIcon from 'images/close-icon.svg';

const LinkEditSchema = yup.object().shape({
  name: yup
    .string()
    .min(2, 'Must be at least 2 characters')
    .when('variety', {
      is: val => val === TEXT_LINK,
      then: yup.string().required("Link name can't be empty"),
    }),
  image: yup.mixed().when('variety', {
    is: val => val === IMAGE_LINK,
    then: yup.mixed().required("Image link can't be empty"),
  }),
  url: yup
    .string()
    .url('Please input your site url')
    .required("URL can't be empty"),
  variety: yup.string(),
});

class LinkEdit extends Component {
  state = {
    isImageLoading: false,
  };

  spinnerStart = () => {
    this.setState({ isImageLoading: true });
  };

  spinnerStop = () => {
    this.setState({
      isImageLoading: false,
    });
  };

  handleSetImage = e => {
    this.spinnerStart();
    e.persist();
    const { setFieldValue } = this.props;
    setFieldValue('image', e.target.files[0]);
    this.spinnerStop();
  };

  handleApprove = () => {
    this.props.onApprove(this.props.link.id);
  };

  render() {
    const {
      onEditCancel,
      handleSubmit,
      touched,
      errors,
      link,
      values,
    } = this.props;

    let editInput;

    if (link.variety === TEXT_LINK) {
      editInput = (
        <Field
          name="name"
          component={FieldInputComponent}
          error={touched.name && errors.name}
          type="text"
          id="edit-link-name"
          classInput="form-input input-border"
        />
      );
    } else {
      editInput = (
        <div className="upload-img">
          <Field
            name="image"
            component={FieldUploadImage}
            error={touched.image && errors.image}
            idUploadInput="edit-upload-link-img"
            isImageLoading={this.state.isImageLoading}
            inputClass="upload-img__input"
            labelClass="upload-img__label"
            helpText={values.image.name || 'Formats: jpg, jpeg, png.'}
            setFiles={this.handleSetImage}
            label="Upload your image"
          />
        </div>
      );
    }

    return (
      <div className="link-itm">
        <div className="link-itm__row edit">
          <div className="link-itm__dnd">
            <img src={listDropImg} alt="" />
          </div>
          <div className="link-itm__inner">
            <div className="link-itm__col">
              <div className="link-itm__descr">
                <div className="link-itm__icon">
                  <img src={this.iconSrc} alt="" />
                </div>
                <div className="link-itm__edit">{editInput}</div>
              </div>
            </div>
            <div className="link-itm__col">
              <Field
                name="url"
                component={FieldInputComponent}
                error={touched.url && errors.url}
                type="text"
                id="edit-link-name"
                classInput="form-input input-border"
              />
            </div>
          </div>
        </div>

        <div className="link-itm__controls show">
          <ButtonCustom
            className="btn-control btn-edit"
            type="button"
            onClick={handleSubmit}
            buttonImg={checkedIcon}
          />
          <ButtonCustom
            className="btn-control btn-delete"
            type="button"
            onClick={onEditCancel}
            buttonImg={closeIcon}
          />
        </div>
      </div>
    );
  }
}

export default withFormik({
  mapPropsToValues: props => ({
    name: props.link.name,
    url: props.link.url,
    image: props.link.image,
    variety: props.link.variety,
  }),
  validationSchema: LinkEditSchema,
  handleSubmit: async (values, { props, setSubmitting }) => {
    await props.onApprove(values, props.link.id);
    setSubmitting(false);
  },
})(LinkEdit);



// WEBPACK FOOTER //
// ./src/components/LinkEdit/LinkEdit.js